import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSaopaulometroComponent } from './simple-icons-saopaulometro.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSaopaulometroComponent ],
    exports:      [ SimpleIconsSaopaulometroComponent ],
    bootstrap:    []
})
export class SimpleIconsSaopaulometroModule {}
